import React from 'react';
import { useSelector } from 'react-redux';
import { newObjectCreater } from '../../../../../utils/controller';
import InputField from '../../../../../component/form/FormInput';
import InputSelect from '../../../../../component/inputSelect/InputSelect';

const Address = ({ data, setData, error, cityList, disabled }) => {
	let masterData = useSelector((state) => state?.master?.masterData?.data);

	const countryList = newObjectCreater(masterData?.countries);
	const StateList = newObjectCreater(masterData?.states);

	const handleCustomerAddress = (key, value) => {
		setData((prev) => ({
			...prev,
			address: {
				...prev.address,
				[key]: value,
			},
		}));
	};

	return (
		<div>
			<div className="row">
				<div className="col">
					<InputField
						label="Attention "
						placeholder="Attention"
						type="text"
						autoComplete="off"
						value={data.attention}
						onChange={(value) => handleCustomerAddress('attention', value)}
						disabled={disabled}
					/>
				</div>
				<div className="col">
					<InputSelect
						label="Country "
						placeholder="Select Country"
						autoComplete="off"
						onChange={(value) => {}}
						onSelect={(value) => {
							handleCustomerAddress('country_id', Number(value.key));
						}}
						value={data.country_id}
						options={countryList}
						disabled={disabled}
						error={error?.country_id}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<InputField
						label="Address Street 1"
						placeholder="Address Street 1"
						type="text"
						autoComplete="off"
						value={data.street_1}
						onChange={(value) => handleCustomerAddress('street_1', value)}
						disabled={disabled}
					/>
				</div>
				<div className="col">
					<InputField
						label="Address Street 2 "
						placeholder="Address Street 2"
						autoComplete="off"
						type="text"
						value={data.street_2}
						onChange={(value) => handleCustomerAddress('street_2', value)}
						disabled={disabled}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<InputSelect
						label="State"
						placeholder="Select State"
						autoComplete="off"
						onChange={(value) => {}}
						onSelect={(value) => {
							handleCustomerAddress('state_id', value.key);
						}}
						value={data.state_id}
						options={StateList}
						disabled={disabled}
						error={error?.state_id ? 'is not allowed to be empty.' : ''}
					/>
				</div>
				<div className="col">
					<InputSelect
						label="City"
						placeholder="Select City"
						autoComplete="off"
						onChange={(value) => {}}
						onSelect={(value) => handleCustomerAddress('city_id', value.key)}
						value={data.city_id}
						options={cityList}
						disabled={disabled}
						error={error?.city_id ? 'is not allowed to be empty.' : ''}
					/>
				</div>
				<div className="col">
					<InputField
						label="Zip Code"
						placeholder="Zip code"
						type="text"
						autoComplete="off"
						maxLength={6}
						style={{ textAlign: 'right' }}
						value={data.zip_code}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleCustomerAddress('zip_code', value);
						}}
						disabled={disabled}
					/>
				</div>
			</div>
		</div>
	);
};

export default Address;
